<!--     
    TOOLBAR
 -->
<mat-toolbar>
    <button matIconButton aria-label="Open drawer" (click)="toggle()" id="menuButton" [ngClass]="{'hide':!browsersniffer.isMobile()}">
        <mat-icon>menu</mat-icon>
    </button>
    <!--  MOBILE -->
    <ng-container [ngClass]="{'hide':!browsersniffer.isMobile()}"
        *ngTemplateOutlet="mobileToolbarTemplate"></ng-container>
    <!--  DESKTOP -->
    <ng-container [ngClass]="{'hide':browsersniffer.isMobile()}"
        *ngTemplateOutlet="desktopToolbarTemplate"></ng-container>
    <!--  COMMON -->
    <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
</mat-toolbar>
<!--     
    MOBILE DRAWER
 -->
<ng-template #ttHeaderDrawer>
    <div [ngClass]="{'hide':!browsersniffer.isMobile()}" style="display: contents;">
        <div class="tt-header-drawer" [class.open]="isOpen()" (transitionend)="onDrawerTransitionEnd($event)">
            <div class="tt-header-drawer-inner">
                <button matIconButton type="button" class="close" matTooltipPosition="above" (click)="close()" 
                    matTooltip="drawer.close"><mat-icon>close</mat-icon></button>
                <ng-container *ngTemplateOutlet="mobileContentDrawerTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #logoTemplate>
    <ng-content select="[logoTemplate]"> </ng-content>
</ng-template>
<ng-template #mobileContentDrawerTemplate>
    <ng-content select="[mobileContentDrawerTemplate]"> </ng-content>
</ng-template>
<ng-template #mobileToolbarTemplate>
    <ng-content select="[mobileToolbarTemplate]"> </ng-content>
</ng-template>
<ng-template #desktopToolbarTemplate>
    <ng-content select="[desktopToolbarTemplate]"> </ng-content>
</ng-template>
<ng-template #toolbarTemplate>
    <ng-content select="[toolbarTemplate]"> </ng-content>
</ng-template>